import classnames from 'classnames/bind'
import Image from '@/components/common/Image'
import { isEmpty } from 'lodash-es'
import { useAppSelector } from '@/redux/hooks'

// Libs

// Components
import Link from '@/components/common/Link'
import Icon from '@/assets/icons'

// Constants
import { ROUTE_PATH } from '@/constants/routePath'

// Styles
import styles from './style.module.scss'

// Variables
const cx = classnames.bind(styles)

function SimpleHeader() {
  const memberData = useAppSelector((state) => state?.member?.memberData)

  const handleHumanIconClick = () => {
    window.open('/')
  }

  return (
    <header className={cx('header')}>
      <div className={cx('header__wrapper')}>
        <Link pathname={ROUTE_PATH.HOME}>
          <div className={cx('header-logo')}>
            <Image src={'/images/svg/logo.svg'} fill alt={'TutorABC Shop'} />
          </div>
        </Link>
        <div className={cx('header__right')}>
          {!isEmpty(memberData.refCode) && <div className={cx('header__code')}>ID: {memberData.refCode}</div>}
          <button onClick={handleHumanIconClick} className={cx('header__icon')}>
            <Icon.Human />
          </button>
        </div>
      </div>
    </header>
  )
}

export default SimpleHeader
